import React from 'react';
import {
  AttentionIcon,
  MedalRewardIcon,
} from '../../../assets/svg/SVGComponents';
import { podium, tones } from '../../../styles/brand';
import { Plain, Rank, Wrapper } from './styles';

interface IPositionBadgeProps {
  /** null quando a equipe não tem posição (ex.: desclassificada). */
  position: number | null;
  disqualified?: boolean;
}

/** Posição na classificação: medalha para o pódio, número para o resto. */
const PositionBadge: React.FC<IPositionBadgeProps> = ({
  position,
  disqualified = false,
}) => {
  if (disqualified) {
    return (
      <Wrapper $color={tones.red.solid} aria-label="Desclassificada">
        <AttentionIcon stroke="currentColor" strokeWidth={1.75} fill="none" />
      </Wrapper>
    );
  }

  if (position === null) return <Plain aria-label="Sem posição">—</Plain>;

  if (position >= 1 && position <= 3) {
    const color = podium[position as 1 | 2 | 3];
    return (
      <Wrapper $color={color} aria-label={`${position}º lugar`}>
        <MedalRewardIcon stroke="currentColor" strokeWidth={1.5} fill="none" />
        <Rank $color={color} aria-hidden>
          {position}
        </Rank>
      </Wrapper>
    );
  }

  return <Plain aria-label={`${position}º lugar`}>{position}</Plain>;
};

export default PositionBadge;
